import * as React from "react";
import { FC, useState } from "react";
import { IFilterConfig } from "../Map/config";
import { IPadding, IUpdates, IVisibleLayer } from "../Map/mapProvider";
import { Feature } from "ol";
import { DemoPaddingControl, DemoMapVisibilityControl } from "./DemoControls";
import { DemoContextProvider } from "./DemoContext";
import { DemoSearch } from "./DemoSearch";
import { DemoFeatures } from "./DemoFeatures";
import { DemoFilters } from "./DemoFilters";

export interface IDemoUIProps {
  /**
   * available filters config
   */
  filtersConfig: IFilterConfig[];
  /**
   * objects (features), filtered according filters.
   * if no filters selected, then all objects (features)
   */
  filteredObjects: Feature[];
  /**
   * objects (features), filtered on text search field change
   * empty array, if no text in search field
   */
  filteredByText: Feature[];
  /**
   * identified object attributes, received on map object click
   */
  identifiedObject: Feature;
  /**
   * callback on Search field value change, to get search results/suggestions
   */
  onSearchUpdate: (currentFilters: any, text: string) => void;
  /**
   * callback on Apply search and filters button click, to get objects according search and filter values
   */
  onApplySearchResults: (currentFilters: any, searchFieldValue: string) => void;
  /**
   * callback, on map visibility state change
   * @param isMapVisible boolean, describes visibility state
   */
  onMapToggle: (isMapVisible: boolean) => void;
  /**
    /**
     * callback, when ZoomTo button clicked, to zoom to particular object
     * @param graphic is any Feature to zoom to
     */
  onZoomToGraphic: (graphic: Feature) => void;
  /**
   * callback, to update feature attributes
   * @param graphic is particular Feature to update
   * @param updates is object containing attributes to update and new values for them
   */
  onUpdateAttributes: (graphic: Feature, updates: IUpdates) => void;
  /**
   * callback, to show or hide circle for nearby objects filter
   * @param enabled boolean, true if show circle
   */
  onNearbyChange: (enabled: boolean) => void;
  /**
   * callback, to change map center, by adding padding
   */
  onChangePadding?: (padding: IPadding) => void;
}

export const DemoUI: FC<IDemoUIProps> = (props: IDemoUIProps) => {
  return (
    <DemoContextProvider>
      <DemoPaddingControl
        onChangePadding={props.onChangePadding}
      ></DemoPaddingControl>
      <DemoMapVisibilityControl
        onMapToggle={props.onMapToggle}
      ></DemoMapVisibilityControl>

      <>
        {/* <DemoSearch
          filteredByText={props.filteredByText}
          onApplySearchResults={props.onApplySearchResults}
          onSearchUpdate={props.onSearchUpdate}
        ></DemoSearch>

        <DemoFilters
          filtersConfig={props.filtersConfig}
          onNearbyChange={props.onNearbyChange}
        ></DemoFilters> */}

        <DemoFeatures
          filteredObjects={props.filteredObjects}
          identifiedObject={props.identifiedObject}
          onZoomToGraphic={props.onZoomToGraphic}
          onUpdateAttributes={props.onUpdateAttributes}
        ></DemoFeatures>
      </>
    </DemoContextProvider>
  );
};
